import service from "@/store/services/product-service";

const state = {
  products: {},
  current_page: {
    principal: null,
    subpage: null,
  },
};

const mutations = {
  SET_PRODUCTS: (state, list) => {
    state.products = list;
  },
  SET_CURRENT_PAGE: (state, page) => {
    state.current_page = page;
  },
};

const actions = {
  read({ commit, dispatch }, params) {
    return service.read(params).then(({ products }) => {
      commit("SET_PRODUCTS", products);
    });
  },
  get({ _ }, params) {
    return service.get(params).then(({ product }) => {
      return Promise.resolve(product);
    });
  },
  setCurrentPage({ commit }, params) {
    commit("SET_CURRENT_PAGE", {
      principal: params.principal ?? null,
      subpage: params.subpage ?? null,
    });
  },
  getProductByCategoryId({ _ }, params) {
    return service.getProductByCategoryId(params).then(({ products }) => {
      return products;
    });
  },
  attachFiles({ _ }, params) {
    return service.attachFiles(params).then(({ product }) => {
      return product;
    });
  },
  getFiles({ _ }, product_id) {
    return service.getFiles(product_id).then(({ files }) => {
      return files;
    });
  },
  removeFile({ _ }, params) {
    return service.removeFile(params);
  },
  getDimensionsById({ _ }, product_id) {
    return service.getDimensionsById(product_id).then((response) => {
      return response;
    });
  },
  exportCsv({ _ }) {
    return service
      .exportCsv()
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  },
  importCsv({ _ }, params) {
    return service.importCsv(params);
  },
  setMarginToProductCategory({ _ }, params) {
    switch (params.category_id) {
      case "Inversores":
        params.category_id = "1";
        break;
      case "Módulos":
        params.category_id = "2";
        break;
      case "Estruturas":
        params.category_id = "3";
        break;
      case "Outros":
        if (params.other_product === "StringBox") {
          params.category_id = "4";
        }
        if (params.other_product === "Conectores") {
          params.category_id = "5";
        }
        if (params.other_product === "Cabox") {
          params.category_id = "6";
        }
        break;
    }
    return service.setMarginToProductCategory(params);
  },
};

const getters = {
  products: (state) => state.products,
  current_page: (state) => state.current_page,
};

const product = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default product;
